import './news-filter.style.scss'

export class NewsFilterComponent extends HTMLElement {
    private input!: HTMLInputElement
    private form!: HTMLFormElement
    private minScoreInput!: HTMLInputElement

    connectedCallback() {
        this.render()
        this.cacheElements()
        this.attachEvents()
    }

    private render() {
        this.innerHTML = `
            <div class="tbw-news-filter">
                <form class="tbw-news-filter-form">
                    <input
                        type="text"
                        class="tbw-news-filter-input"
                        placeholder="Filter news by keywords"
                    />
                    <button type="submit" class="tbw-news-filter-submit">
                        Filter
                    </button>
                </form>
                <div class="tbw-news-filter-tags">
                    <button type="button" class="tbw-news-filter-tag" data-keyword="bitcoin">bitcoin</button>
                    <button type="button" class="tbw-news-filter-tag" data-keyword="ethereum">ethereum</button>
                    <button type="button" class="tbw-news-filter-tag" data-keyword="solana">solana</button>
                    <button type="button" class="tbw-news-filter-tag" data-keyword="tether">tether</button>
                    <button type="button" class="tbw-news-filter-tag" data-keyword="usdc">usdc</button>
                </div>
                <div class="tbw-news-filter-tags">
                    <button type="button" class="tbw-news-filter-tag" data-keyword="stablecoins">stablecoins</button>
                    <button type="button" class="tbw-news-filter-tag" data-keyword="tokenization">tokenization</button>
                    <button type="button" class="tbw-news-filter-tag" data-keyword="etfs">etfs</button>
                    <button type="button" class="tbw-news-filter-tag" data-keyword="regulation">regulation</button>
                    <button type="button" class="tbw-news-filter-tag" data-keyword="mica">mica</button>
                </div>
                <div class="tbw-news-filter-tags">
                    <button type="button" class="tbw-news-filter-tag" data-keyword="france">france</button>
                    <button type="button" class="tbw-news-filter-tag" data-keyword="switzerland">switzerland</button>
                    <button type="button" class="tbw-news-filter-tag" data-keyword="US">US</button>
                    <button type="button" class="tbw-news-filter-tag" data-keyword="UK">UK</button>
                </div>
                <div class="tbw-news-filter-tags">
                    <button type="button" class="tbw-news-filter-tag" data-keyword="blockworks">blockworks</button>
                    <button type="button" class="tbw-news-filter-tag" data-keyword="decrypt">decrypt</button>
                    <button type="button" class="tbw-news-filter-tag" data-keyword="theblock">theblock</button>
                    <button type="button" class="tbw-news-filter-tag" data-keyword="coindesk">coindesk</button>
                    <button type="button" class="tbw-news-filter-tag" data-keyword="bankless">bankless</button>
                    <button type="button" class="tbw-news-filter-tag" data-keyword="protos">protos</button>
                    <button type="button" class="tbw-news-filter-tag" data-keyword="ledger insights">ledger insights</button>
                    <button type="button" class="tbw-news-filter-tag" data-keyword="banking dive">banking dive</button>
                    <button type="button" class="tbw-news-filter-tag" data-keyword="the defiant">the defiant</button>
                    <button type="button" class="tbw-news-filter-tag" data-keyword="dl news">dl news</button>
                    <button type="button" class="tbw-news-filter-tag" data-keyword="bitcoin magazine">bitcoin magazine</button>
                </div>
            </div>
        `
    }

    private cacheElements() {
        this.form = this.querySelector('.tbw-news-filter-form') as HTMLFormElement
        this.input = this.querySelector('.tbw-news-filter-input') as HTMLInputElement
        this.minScoreInput = this.querySelector('.tbw-news-filter-min-score') as HTMLInputElement
    }

    private attachEvents() {
        this.form?.addEventListener('submit', (event) => {
            event.preventDefault()
            this.applyFilter(this.input.value)
        })

        const tags = this.querySelectorAll<HTMLButtonElement>('.tbw-news-filter-tag')
        tags.forEach((tag) => {
            tag.addEventListener('click', (event) => {
                event.preventDefault()
                const keyword = tag.dataset.keyword || tag.textContent?.trim() || ''
                this.input.value = keyword
                this.applyFilter(keyword)
            })
        })
    }

    private async applyFilter(rawKeywords: string) {
        const keywords = rawKeywords.trim()
        const minRaw = this.minScoreInput?.value.trim() ?? ''
        const minScore = minRaw || null

        const newsComponent = document.querySelector('tbw-news') as (HTMLElement & {
            applyKeywordsFilter?: (keywords: string | null, minScore?: string | null) => Promise<void>
        }) | null

        if (!newsComponent) { return }

        if (typeof newsComponent.applyKeywordsFilter === 'function') {
            await newsComponent.applyKeywordsFilter(keywords || null, minScore)
        } else {
            if (keywords) {
                newsComponent.setAttribute('data-news-keywords', keywords)
            } else {
                newsComponent.removeAttribute('data-news-keywords')
            }

            if (minScore) {
                newsComponent.setAttribute('data-news-minScore', minScore)
            } else {
                newsComponent.removeAttribute('data-news-minScore')
            }
        }
    }
}

